import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Formik } from 'formik';
import TextInput from 'web/components/form-elements/TextInput';
import { getInitialValues } from 'web/components/utils/profileUtils';
import styles from './profile.module.scss';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ProfilePicture from 'web/components/ProfilePicture';
import DP from 'web/assets/images/userPicDummy.jpeg'
import styled from 'styled-components'
import { setCurrentLanguage, fetchLanguageContentNew } from 'redux/actions/language';
import userName from 'web/assets/images/user-name.png';


const Profile = ({ pageData }) => {
  const dispatch = useDispatch();
  const currentLocalization = localStorage.getItem('currentLocalization');
  const currentLanguage = useSelector(state => state.language.currentLanguage)
  const languageContentNew = useSelector(state => state.language.languageContentNew)
  const [pageLanguageContents, setPageLanguageContents] = useState()

  useEffect(() => {
    dispatch(fetchLanguageContentNew(currentLocalization))
    dispatch(setCurrentLanguage(currentLocalization))
  }, [currentLanguage]);

  useEffect(() => {
    if (languageContentNew?.H8_Nav_Profile_Page) setPageLanguageContents(languageContentNew.H8_Nav_Profile_Page)
  }, [languageContentNew])

  return (
    < >
      {pageData && <Formik
        initialValues={getInitialValues(pageData)}
        onSubmit={(values) => {
        }}>
        {(props) => {
          const { isValid, dirty, values, errors, touched, setFieldValue, } = props;
          return (
            <>
              <Form>
                <Container>
                  <div className={styles.maxWidth}>
                    <div></div>
                    <div className={styles.profile}>
                      <div className="profile-sec">
                        <div class="community-details-header seller">
                          <div class="community-name">
                            <h4>
                              {pageLanguageContents?.Account_Details[0]?.Title}
                            </h4>
                          </div>
                        </div>
                        <div className="row">
                          <div className="profile-pic-row col-sm-12">
                            <ProfilePicture
                              name="profileImg"
                              props={props}
                              profileImagePath={pageData?.profileImage}
                              Picture={DP}
                              ProfileName=""
                              CompanyName=""
                              pageType=""
                            />
                          </div>
                          <div className="col-sm-4 form-group">
                            <label className="form-label">
                              {pageLanguageContents?.Account_Details[1]?.Name}
                            </label>
                            <TextInput
                              name="name"
                              inputType="textAndNumber"
                              placeholder="Enter Name*"
                              showErrorMessages={true}
                              disabled={true}
                            />
                          </div>
                          <div className="col-sm-4 form-group">
                            <label className="form-label">
                              {pageLanguageContents?.Account_Details[3]?.Email}
                            </label>
                            <div className="input-group">
                              <TextInput
                                name="email"
                                placeholder="Enter Email*"
                                maxLength={100}
                                showErrorMessages={true}
                                disabled={true}
                              />
                              <span className="input-group-text text-success">
                                <CheckCircleIcon />
                                {pageLanguageContents?.Account_Details[4]?.Verified}
                              </span>
                            </div>
                          </div>
                          <div className="col-sm-4 form-group">
                            <label className="form-label">
                              {pageLanguageContents?.Account_Details[5]?.Company}
                            </label>
                            <TextInput
                              name="companyName"
                              placeholder="Enter company name*"
                              showErrorMessages={true}
                              disabled={true}
                            />
                          </div>
                          <div className="col-sm-6 col-md-4 form-group">
                            <label htmlFor="" className="form-label">
                              {pageLanguageContents?.Account_Details[6]?.Add1}
                            </label>
                            <TextInput
                              name="line1"
                              placeholder="line1*"
                              showErrorMessages={true}
                              disabled={true}
                            />
                          </div>
                          <div className="col-sm-6 col-md-4 form-group">
                            <label htmlFor="" className="form-label">
                              {pageLanguageContents?.Account_Details[7]?.Add2}
                            </label>
                            <TextInput
                              name="line2"
                              placeholder={"Apt, suite, unit, building, floor, etc."}
                              showErrorMessages={true}
                              disabled={true}
                            />
                          </div>
                          <div className="col-sm-6 col-md-4 form-group">
                            <label htmlFor="" className="form-label">
                              {pageLanguageContents?.Account_Details[8]?.City}
                            </label>
                            <TextInput
                              name="city"
                              placeholder="city*"
                              showErrorMessages={true}
                              disabled={true}
                            />
                          </div>
                          <div className="col-sm-6 col-md-4 form-group">
                            <label htmlFor="" className="form-label">
                              {pageLanguageContents?.Account_Details[9]?.State}
                            </label>
                            <TextInput
                              name="state"
                              placeholder="State"
                              showErrorMessages={true}
                              disabled={true}
                            />
                          </div>
                          <div className="col-sm-6 col-md-4 form-group">
                            <label htmlFor="" className="form-label">
                              {pageLanguageContents?.Account_Details[10]?.Zip}
                            </label>
                            <TextInput
                              name="zip"
                              placeholder="zip*"
                              showErrorMessages={true}
                              disabled={true}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Container>
              </Form>
            </>
          );
        }}
      </Formik >}
    </>
  )
};

export default Profile;

const Container = styled.div`
    max-width: 1407px;
    padding: 15px 10px;
    margin: 0 auto;
    @media (max-width:1250px) {
        padding: 15px;
    }

    @media (max-width: 767px) {
      .app-input-text {
          margin-bottom: 5px;
      }
    }  
`